import { useMemo, useState } from "react";

import classNames from "classnames";
import { Search } from "neetoicons";
import { Input, Typography } from "neetoui";
import { useTranslation } from "react-i18next";

import Content from "./Content";
import { useFetchNeetoApps } from "./hooks/useNeetoApps";
import useProductSwitcherNavigation from "./hooks/useProductSwitcherNavigation";
import "./product-switcher.scss";

const Menu = ({ isMobile = false, initialFocusRef }) => {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState("");

  const { data, isLoading } = useFetchNeetoApps();

  const substring = searchTerm.replace(/ /g, "").toLowerCase();

  const filteredApps = useMemo(() => {
    if (!data) return [];

    return data?.neetoApps.filter(({ name }) => {
      const nameLower = name.toLowerCase();
      const searchTermLower = substring.toLowerCase();

      const isNeetoPrefixMatch =
        searchTermLower.length <= 4 && "neeto".startsWith(searchTermLower);

      if (isNeetoPrefixMatch) return true;

      const productName = searchTermLower.startsWith("neeto")
        ? searchTermLower.replace("neeto", "")
        : searchTermLower;

      return nameLower.includes(productName);
    });
  }, [data, substring]);

  const { highlightedIndex, handleKeyDown, scrollContainerRef } =
    useProductSwitcherNavigation(filteredApps);

  return (
    <div
      className="neeto-molecules-product-switcher__wrapper"
      data-testid="switcher-wrapper"
      key="switcher-wrapper"
    >
      <div
        data-testid="product-switcher-body-wrapper"
        className={classNames("neeto-molecules-product-switcher__header pt-1", {
          "neeto-molecules-product-switcher__header-mobile": isMobile,
        })}
      >
        {!isMobile && (
          <Typography style="h1">
            {t("neetoMolecules.productSwitcher.chooseNeetoProduct")}
          </Typography>
        )}
        <div className="neeto-molecules-product-switcher__search-wrapper">
          <Input
            autoFocus
            data-testid="product-switcher-search-input"
            placeholder={t("neetoMolecules.productSwitcher.searchProducts")}
            prefix={<Search />}
            ref={initialFocusRef}
            size="large"
            type="search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>
      <div
        ref={scrollContainerRef}
        className={classNames("neeto-molecules-product-switcher__body", {
          ["neeto-molecules-product-switcher__body-mobile"]: isMobile,
        })}
      >
        <Content {...{ filteredApps, highlightedIndex, isLoading }} />
      </div>
    </div>
  );
};

export default Menu;
